// iOS Safari can leave remote <audio> and <video> elements paused even though the WebRTC
// stream is live and decoding (video-ui#13: audio and video both silent while packets
// arrived with no loss). These helpers let the page start playback itself, from a user
// gesture when the browser demands one.

export function mediaElements(): Array<HTMLAudioElement | HTMLVideoElement> {
  return Array.from(document.querySelectorAll('audio, video')) as Array<HTMLAudioElement | HTMLVideoElement>;
}

// Elements that have a stream attached but are not playing.
export function stalledMedia(): Array<HTMLAudioElement | HTMLVideoElement> {
  return mediaElements().filter(el => el.srcObject && el.paused);
}

// Calls play() on every stalled element. Video stays muted (autoplay-safe; its audio is a
// separate element). Returns how many elements were started.
export async function playStalledMedia(): Promise<number> {
  let started = 0;
  await Promise.all(
    stalledMedia().map(async el => {
      if (el instanceof HTMLVideoElement) {
        el.muted = true;
        el.setAttribute('playsinline', '');
      }
      try {
        await el.play();
        started += 1;
      } catch (e) {
        // Still blocked; the caller keeps showing the tap prompt.
      }
    })
  );
  return started;
}
